interface AlertCircleProps {
  stroke?: string;
  size?: string;
}

const AlertCircleIcon = ({
  stroke = 'var(--text-error)',
  size = '16',
}: AlertCircleProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <circle cx='8' cy='8' r='6.5' stroke={stroke} strokeWidth='1.5' />
    <path
      d='M8 5V8.5'
      stroke={stroke}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <circle cx='8' cy='11' r='0.75' fill={stroke} />
  </svg>
);

export default AlertCircleIcon;
